import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import LoadingIndicator from 'components/LoadingIndicator';
import SafeMarkdown from 'components/SafeMarkdown';
import { errorShape } from 'utils/shapes';

function ResponsibleGamingContent({ responsibleGamingData }) {
  const { responsibleGamingAsMarkdown, loading, error } = responsibleGamingData;
  let content;

  if (loading) {
    content = <LoadingIndicator />;
  } else if (error || !responsibleGamingAsMarkdown) {
    content =
      'An error occured while fetching the terms of service. Please try again.';
  } else {
    content = (
      <SafeMarkdown
        source={responsibleGamingAsMarkdown.responsibleGaming}
        role="article"
      />
    );
  }
  return <div className="terms-of-service-content">{content}</div>;
}

const QUERY_GET_RESPONSIBLE_GAMING = gql`
  query MyGetResponsibleGaming {
    responsibleGamingAsMarkdown {
      responsibleGaming
    }
  }
`;

ResponsibleGamingContent.propTypes = {
  responsibleGamingData: PropTypes.shape({
    responsibleGamingAsMarkdown: PropTypes.shape({
      responsibleGaming: PropTypes.string
    }),
    loading: PropTypes.bool,
    error: errorShape
  })
};

const withData = compose(
  graphql(QUERY_GET_RESPONSIBLE_GAMING, { name: 'responsibleGamingData' })
);

export default withData(ResponsibleGamingContent);
